import { render } from "./App.vue?vue&type=template&id=7e7cc0c3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7e7cc0c3&lang=css"
script.render = render

export default script